/* global $ */

import expand from './expand'

const CONTAINER_SELECTOR = '[data-module="ajax-section"]'
const IGNORE = 'data-ajax-ignore'
const CURSOR_WAIT = 'cursor-wait'

const body = document.body

/*
  This works because it is encapsulated in a single element.
*/

export default function () {
  // No more than one.
  let $element = document.querySelector(CONTAINER_SELECTOR)
  if ($element != null) init($element)
}

function init (element) {
  element.addEventListener('click', onClick)

  function onClick (event) {
    let { target } = event

    if (target.hasAttribute(IGNORE) || target.tagName.toUpperCase() !== 'A') { return }

    event.preventDefault()
    body.classList.add(CURSOR_WAIT)

    let url = target.href
    // Using jQuery, haha
    $(element).load(url + ' ' + CONTAINER_SELECTOR, function done (
      response,
      status
    ) {
      if (status === 'error') {
        window.location.href = url
        return
      }
      body.classList.remove(CURSOR_WAIT)
      window.scrollTo(0, 0)
      expand(element)
    })
  }
}
